import { ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's own scales, so the theme's custom names need
 * registering or they are misread:
 * - `border-edge` is a width. Unregistered it reads as a border colour and is
 *   dropped when `border-lit-edge` (the colour) comes later, so an emphasised card
 *   lost its border.
 * - Every custom shadow name reads as a shadow colour unless listed, and then it
 *   sits beside another shadow utility instead of replacing it.
 * - The dusk gradients are background images. Unregistered they read as background
 *   colours, so a gradient and a colour cancelled each other.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "border-w": [{ border: ["edge", "cta-w"] }],
      shadow: [
        {
          shadow: [
            "lit",
            "lit-strong",
            "lit-dot",
            "lit-cta",
            "lit-card",
            "cta",
            "card",
            "card-hover",
            "modal",
            "dropdown",
          ],
        },
      ],
      "bg-image": [
        {
          bg: [
            "dusk-hero",
            "dusk-chapter-1",
            "dusk-chapter-2",
            "dusk-chapter-3",
            "dusk-live",
            "dusk-tile-a",
            "dusk-tile-b",
            "cta-image",
            "gradient-navy",
            "gradient-page",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
